import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {DROPZONE_CONFIG, DropzoneConfigInterface, DropzoneModule} from 'ngx-dropzone-wrapper';
import {UploadDropZoneComponent} from './upload-dropzone/upload-dropzone.component';
import {IntlTellInputComponent} from './intl-tell-input/intl-tell-input.component';
import {Ng2TelInputModule} from 'ng2-tel-input';
import { PrintListConfirmedComponent } from './print-list-confirmed/print-list-confirmed.component';
import { SpinnerComponent } from './spinner/spinner.component';
import {OverviewModalComponent} from './overview-modal/overview-modal.component';
import {SharedModule} from '../shared/shared.module';

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
    url: 'https://server.ozshuttle.com/api/upload/upload.php',
    headers: {
        'Cache-Control': null
    },
    maxFilesize: 50,
    acceptedFiles: 'image/*, application/pdf'
};

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        NgbModule,
        FormsModule,
        DropzoneModule,
        Ng2TelInputModule,
        SharedModule
    ],
    declarations: [
        UploadDropZoneComponent,
        IntlTellInputComponent,
        PrintListConfirmedComponent,
        SpinnerComponent,
        OverviewModalComponent
    ],
    exports: [
        UploadDropZoneComponent,
        IntlTellInputComponent,
        PrintListConfirmedComponent,
        SpinnerComponent,
        OverviewModalComponent
    ],
    providers: [
        {
            provide: DROPZONE_CONFIG,
            useValue: DEFAULT_DROPZONE_CONFIG
        }
    ]
})

export class GlobalModule {
}
